export default __webpack_public_path__ + "static/media/question5-mobile.69349837.png";